import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import UserDataService from '../../../services/UserDataService';
import { TOASTER_VARIANT } from '../../components/toast/constants';
import { GENERIC_ERROR_MESSAGE, PAGE_STATE } from '../constants/constants';
import { ONBOARDING_ROUTES } from '../onboarding/constants';
import { addNotifications } from '../toaster/ToasterPortalSlice';
import { componentKey, setErrorInProfile, setLoadingState, setOnboardingPending, setOnBoardingScreenToStart } from './DashboardSlice';
import { setSignedInUser } from '../authentication/AuthenticationSlice';
import RightsManagementDataService from '../../../services/RightsManagementDataService';
import { setPermissions } from '../loaders/dataloader/DataLoaderSlice';
import { PAGE_PERMISSIONS } from './constants/constant';
import { DASHBOARD_STATES } from './constants';

export const { getUserProfileAndPermissions, getUpdatedSignedInUserProfile } = {
    getUserProfileAndPermissions: (payload) => {
        return {
            type: "DASHBOARD/GET_USER_PROFILE_AND_PERMISSIONS",
            payload: payload
        }
    },
    getUpdatedSignedInUserProfile: (payload) =>{
		return {
			type: "DASHBOARD/GET_UPDATED_SIGNED_IN_USER_PROFILE",
			payload
		}
	}
}

function* getUserProfileAndPermissionsAsync(action) {

    try {
        yield put(setLoadingState({ state: DASHBOARD_STATES.PAGE_LOADING }));

        const [profileResponse, permissionsResponse, viewNoticeReponse] = yield all([
            call(UserDataService.getProfile),
            call(RightsManagementDataService.getUserRights),
            call(RightsManagementDataService.getViewNoticesRight),
        ]);

        if (profileResponse.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: profileResponse?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
            yield put(setErrorInProfile(true))
            yield put(setLoadingState({ state: DASHBOARD_STATES.PAGE_READY }))
            return;
        }

        if (permissionsResponse.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: permissionsResponse?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
            yield put(setErrorInProfile(true))
            yield put(setLoadingState({ state: DASHBOARD_STATES.PAGE_READY }))
            return;
        }

        // profile response
        let onBoardingScreenToStart = "";
        let userProfileData = profileResponse.data.Data;

        const onboardingData = [
            {
                condition: !userProfileData.CompanyName || !userProfileData.PhoneNumber,
                route: ONBOARDING_ROUTES.WELCOME,
            },
            {
                condition: !userProfileData.BusinessType,
                route: ONBOARDING_ROUTES.COMPANY_SIZE,
            },
            {
                condition: !userProfileData.FormCount,
                route: ONBOARDING_ROUTES.FORM_QUANTITY,
            },
            {
                condition: !userProfileData.AccountingTypes,
                route: ONBOARDING_ROUTES.ACCOUNTING_SOFTWARES,
            },
        ];

        for (const { condition, route } of onboardingData) {
            if (condition) {
                onBoardingScreenToStart = route;
                break;
            }
        }

        if (userProfileData?.UserType && userProfileData.UserType !== 4 && userProfileData.UserType !== 2 && onBoardingScreenToStart ) {
            yield put(setOnBoardingScreenToStart(onBoardingScreenToStart));
            yield put(setOnboardingPending(true));
        }

        // premissions response    
        let permissions = permissionsResponse.data.Data;
        delete permissions.AdminMasterId;
        delete permissions.Master;
        delete permissions.Member;
        delete permissions.Role;
        delete permissions.HasAccepted;
        delete permissions.Isdeleted;

        yield put(setSignedInUser(userProfileData))
        yield put(setPermissions({...permissions, [PAGE_PERMISSIONS.VIEW_NOTICES]: viewNoticeReponse.data.Data}))

    } catch (error) {
        console.log("error", error)
        yield put(setErrorInProfile(true))
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE,
        }));
    } finally {
        yield put(setLoadingState({ state: DASHBOARD_STATES.PAGE_READY }))
    }
}

function* getUpdatedSignedInUserProfileAsync(action) {
    try {
        yield put(setLoadingState({ state: DASHBOARD_STATES.PAGE_LOADING }));
        const profileResponse = yield UserDataService.getProfile();
        if (profileResponse.data) {
            if (profileResponse?.data?.Status === 0) {
                yield put(setErrorInProfile(true))
                yield put(addNotifications({
                    heading: "Error",
                    message: profileResponse?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                let userProfileData = profileResponse?.data?.Data;
                yield put(setSignedInUser(userProfileData))
            }
        }
    } catch (error) {
        console.log("error:", error)
        yield put(setErrorInProfile(true))
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE,
        }));
    } finally {
        yield put(setLoadingState({ state: DASHBOARD_STATES.PAGE_READY }));

    }
}


function* rootSaga() {
    yield all([
        takeLatest(getUserProfileAndPermissions().type, getUserProfileAndPermissionsAsync),
        takeLatest(getUpdatedSignedInUserProfile().type, getUpdatedSignedInUserProfileAsync)
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);